export default function (...args)
{
	return {

		events: ['change'],

		refresh()	// Inputs of type="file" cannot have their value set by assignment
		{
		},

		handleEvents(ev)
		{
			let reader = new FileReader();
			reader.onloadend = () => 
			{
				let result = reader.result;
				this.setValue(result.slice(result.indexOf(',') + 1));
			};
			reader.readAsDataURL(ev.target.files[0]);
		}

	};
}

